module.exports = __webpack_public_path__ + "img/tron (50).21819302.jpg";